import { get } from '@fable/api'
import { isUUID } from 'utils'

export const getClub = async (slug: string) => {
  const url = isUUID(slug) ? `/clubs/${slug}` : `/clubs/?slug=${slug}`
  return await get(url)
}

export const getClubBooks = async (clubId: string | undefined) =>
  !!clubId && (await get(`/clubs/${clubId}/club_books`))

export const getClubSuggestion = async (bookId: string | undefined) =>
  !!bookId && (await get(`/books/${bookId}/club_suggestion`))
